import {useCallback, useEffect} from "react";
import {useSignal} from "@preact/signals-react";

import {BACKEND_APIS, GROUPED_BY} from "@constants";
import {isBannersPercentageHighLevelLoading} from "../@signals";
import useBannerPercentageSearch from "./useSearch";


export default function useBannerPercentageHighLevel() {
    const shareKey = useSignal(GROUPED_BY.BRAND)
    const forceLoad = useSignal(false)
    const data = useSignal([])

    const isClickedRemaining = ![GROUPED_BY.BRAND, GROUPED_BY.COMPANY].includes(shareKey.value)
    const { isLoading, currentData, previousData, shareTitle, handleDownload } = useBannerPercentageSearch(
        `${BACKEND_APIS.BANNERS}/percentage/wrapped/high-level`,
        forceLoad.value,
        { splitKpi: [GROUPED_BY.COUNTRY, shareKey.value] }
    )

    useEffect(() => {
        forceLoad.value = true
    }, [shareKey.value])

    useEffect(() => {
        if (isLoading) {
            data.value = []
            isBannersPercentageHighLevelLoading.value = true
        } else {
            if (forceLoad.value)
                forceLoad.value = false

            const prevDict = [...previousData].reduce((acc, item) => {
                acc[item.labelID] = item;
                return acc
            }, {})

            data.value = currentData.map(item => {
                const share = item.share ?? null
                const prevShare = prevDict[item.labelID]?.share ?? null
                const diff = share !== null && prevShare !== null ? share - prevShare : null


                if (item?.remainingData?.length) {
                    const prevRemaining = [...prevDict[item.labelID]?.remainingData || []].reduce((acc, rd) => {
                        acc[rd.labelID] = rd;
                        return acc
                    }, {})

                    const labelsID = []
                    item.remainingData = item.remainingData.map(rd => {
                        const labelID = rd.labelID
                        const remainingShare = rd.share ?? null
                        let prevRemainingShare = prevDict[labelID]?.share ?? null
                        if (prevRemainingShare === null)
                            prevRemainingShare = prevRemaining[labelID]?.share ?? null
                        const remainingDiff = remainingShare !== null && prevRemainingShare !== null ? remainingShare - prevRemainingShare : null

                        if (isClickedRemaining)
                            labelsID.push(labelID)

                        return {
                            ...rd,
                            prevShare: prevRemainingShare,
                            diff: remainingDiff
                        }
                    })

                    if (labelsID.length) {
                        if (shareKey.value === GROUPED_BY.PAGE_PRODUCT_TYPE)
                            item.pageProductTypeID = [...labelsID]
                        else if (shareKey.value === GROUPED_BY.PAGE_CATEGORY)
                            item.pageCategoryID = [...labelsID]
                        else if (shareKey.value === GROUPED_BY.IMAGE_TYPE)
                            item.imageTypeID = [...labelsID]
                    }
                }

                return {
                    ...item,
                    prevShare: prevShare,
                    diff
                }
            })
            isBannersPercentageHighLevelLoading.value = false
        }
    }, [isLoading])

    const handleChangeShareKey = useCallback(newValue => {
        shareKey.value = newValue
    }, [])

    return {
        isLoading,
        data: data.value,
        shareKey: shareKey.value,
        isClickedRemaining,
        shareTitle,

        handleChangeShareKey,
        handleDownload
    }
}